'use client';

import clsx from 'clsx';
import { createRef } from 'react';
import { FocusRing, useButton } from 'react-aria';

export interface ShareButtonProps {
  onClickShare?: () => void;
  title: string;
  text: string;
}

export const ShareButton = ({
  onClickShare,
  title,
  text,
}: ShareButtonProps) => {
  const ref = createRef<HTMLButtonElement>();

  const handleClick = () => {
    if (!navigator.share) {
      return;
    }

    navigator
      .share({
        title,
        text,
        url: window.location.href,
      })
      .then(() => {
        onClickShare?.();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const { buttonProps, isPressed } = useButton({ onPress: handleClick }, ref);

  return (
    <FocusRing focusRingClass="ring-3 ring-orange">
      <button
        className={clsx(
          'mx-auto grid touch-none select-none place-items-center rounded-sm bg-transparent p-2 text-white/80 transition focus:border-0 focus:outline-hidden',
          isPressed && 'bg-white/20 text-white backdrop-blur-xs',
        )}
        ref={ref}
        {...buttonProps}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          className="h-6 w-6"
          viewBox="0 0 24 24"
        >
          <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"></path>
          <path d="M16 6L12 2 8 6"></path>
          <path d="M12 2L12 15"></path>
        </svg>
      </button>
    </FocusRing>
  );
};
